import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { generatePath, useLocation } from 'react-router-dom';

import UserRole from '@careerstart/wae-common/src/main/constants/user-role';
import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';

import { showSnackbar } from '../../views/app';
import { ROUTE_CONSTANTS } from '../../views/app/RouteBuilding/routeConstants';

import AdminCard from './components/AdminCard';
import CandidateCard from './components/CandidateCard';
import EmployerCard from './components/EmployerCard';
import RecruiterCard from './components/RecruiterCard';

const UserCard = ({ user, userRole }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const userDetailPath = user?.id
    ? `${generatePath(`/${ROUTE_CONSTANTS.USERS_V2_DETAIL}`, { id: user.id })}${location.search}`
    : undefined;

  const copiedMessage = LanguageConverter('userCard.message.idCopied');

  const ROLE_CARD_MAP = {
    [UserRole.CANDIDATE]: CandidateCard,
    [UserRole.RECRUITER]: RecruiterCard,
    [UserRole.ADMIN]: AdminCard,
    [UserRole.EMPLOYER]: EmployerCard,
  };

  const handleCopyUserId = () => {
    if (!user?.id) return;
    navigator.clipboard.writeText(user.id);
    dispatch(showSnackbar({ message: copiedMessage }));
  };
  const CardComponent = ROLE_CARD_MAP[user?.role];

  return (
    <CardComponent
      user={user}
      onCopyId={handleCopyUserId}
      userDetailPath={userDetailPath}
      userRole={userRole}
    />
  );
};

UserCard.propTypes = {
  user: PropTypes.shape({
    role: PropTypes.string.isRequired,
    id: PropTypes.string,
  }).isRequired,
  userRole: PropTypes.string,
};

export default UserCard;
